import gql from "graphql-tag";

export const REMOVE_MESSAGE = gql`
  mutation ($messageId: ID!) {
    removeMessage(messageId: $messageId) {
      _id
    }
  }
`;
